/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
import React from 'react';

interface DropdownActionItemProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  withModal?: boolean;
  modalTarget?: string;
}

const DropdownActionItem: React.FC<DropdownActionItemProps> = ({
  children,
  onClick,
  className = '',
  withModal = true,
  modalTarget = '#monitoring-modal',
}) => {
  return (
    <button
      type="button"
      className={`dropdown-item p-3 ${className}`}
      {...(withModal && {
        'data-toggle': 'modal',
        'data-target': modalTarget,
      })}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default DropdownActionItem;
